import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DocumentTemplate, DocumentTemplateApiCallerService, UsedTemplateDocuments } from '../services/document-template-api-caller.service';
import Swal from 'sweetalert2';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-edit-used-template',
  templateUrl: './edit-used-template.component.html',
  styleUrl: './edit-used-template.component.scss'
})
export class EditUsedTemplateComponent {
    public form: FormGroup;
    public documentUses: UsedTemplateDocuments[];

  constructor(public dialogRef: MatDialogRef<EditUsedTemplateComponent>, @Inject(MAT_DIALOG_DATA) public data: DocumentTemplate, private fb: FormBuilder, private documentTemplateService: DocumentTemplateApiCallerService) {
    this.form = this.fb.group({
      used: [this.data?.used || '', [Validators.required]]
    });
  }

  ngOnInit() {
    this.getUsedDocuemntTemplate();
  }

  public getUsedDocuemntTemplate() {
    this.documentTemplateService.getUsesDocumenTemplates().subscribe({
      next:(res) => {
        this.documentUses = res;
      }, 
      error: (err) => {
        console.log(err);
      }
    });
  }

  public changueUsedAsing() {
    this.documentTemplateService.asingUseDocumentTemplate(this.data.templateId, this.form.get('used')?.value, false).subscribe({
      next: (result) => {
        Swal.fire({
          icon: 'success',
          titleText: 'Uso Asignado',
          confirmButtonText: 'OK'
        }).then(() => {
          this.dialogRef.close();
        });
      },
      error: (err) => {
        Swal.fire({
          title: 'El Uso ya esta en otra Plantilla',
          text: '¿Desea asignar el uso a esta Plantilla?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sí, Asignar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.documentTemplateService.asingUseDocumentTemplate(this.data.templateId, this.form.get('used')?.value, true).subscribe({
              next: (result) => {
                Swal.fire({
                  icon: 'success',
                  titleText: 'Uso Asignado',
                  confirmButtonText: 'OK'
                }).then(() => {
                  this.dialogRef.close();
                });
              },
              error: (err) => {
                console.log(err);
              }
            });
          }
          else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire({
              icon: 'info',
              titleText: 'Uso no Asignado',
            });
          }
        });
      }
    });
  }

}
